import { useEffect } from 'react';

import { unleashClient } from '../unleashClient/unleashClient';
import { LoggedInUser } from '../../../interfaces/LoggedInUser';

export const useUnleashClient = (loggedInUser: LoggedInUser | null) => {
  useEffect(() => {
    unleashClient.start();

    return unleashClient.stop;
  }, []);

  useEffect(() => {
    if (loggedInUser?.email) {
      unleashClient.updateContext({ userId: loggedInUser.email });
    }
  }, [loggedInUser]);
};
